import { defineStore } from 'pinia'

// 第一个参数是应用程序中 store 的唯一 id
export const user = defineStore('user', {
  state: () => {
    return {
      loginUserData: null
    }
  },
  getters: {},
  actions: {
    setUserInfo(data) {
      this.loginUserData = data
    }
  },
  persist: {
    enabled: true,
  }
})
